







































import Entry from "@/models/Entry";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import VListGroup, { VListGroupItem } from "@/components/VListGroup.vue";
import EntryItem from "@/components/EntryItem.vue";
import ColorHelper from "@/services/ColorHelper";
import { Brand, Company, Product } from "@/models";

@Component({
  components: {
    VListGroup,
    EntryItem,
  },
})
export default class SpecialInitiativesTopList extends Vue {
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop({ default: false }) readonly shareOfVoice!: boolean;
  @Prop({ default: false }) readonly spot!: boolean;
  @Prop({
    default: () => {
      [];
    },
  })
  readonly items!: Array<Company | Brand | Product>;
  @Prop() readonly isOver?: Function;

  rows: Array<Company | Brand | Product> = [];

  get rowItems(): VListGroupItem[] {
    let data = this.rows.map((elem) => elem as any);
    const total = data.reduce((acc, item) => {
      const value = this.spot ? item.detectionsCount : item.secondsCount;
      return acc + value;
    }, 0);
    data = data.map((item) => {
      const value = this.spot ? item.detectionsCount : item.secondsCount;
      return {
        ...item,
        type: item.type,
        shareOfVoice: total !== 0 ? (value / total) * 100 : 0,
      };
    });
    data.sort((a, b) => {
      const [aValue, bValue] = this.spot
        ? [a.detectionsCount, b.detectionsCount]
        : [a.secondsCount, b.secondsCount];
      if (aValue < bValue) {
        return 1;
      } else if (aValue > bValue) {
        return -1;
      }
      return 0;
    });
    return data;
  }

  getColor(id: string): string {
    return ColorHelper.pickForKey(id);
  }

  @Watch("items")
  onItemsChanged(items: Array<Company | Brand | Product>) {
    this.rows = items;
  }

  mounted() {
    this.rows = this.items;
  }

  onItemOver(item: Company | undefined) {
    this.$emit("over", item);
  }

  onEntryClick(item: Company | Brand | Product) {
    const weekRange = this.$route.query.weekRange;
    if (item.type === "companies") {
      this.$router.push({
        name: "SpecialInitiativesCompany",
        params: { companyId: item.id },
        query: { weekRange: weekRange },
      });
    }
    if (item.type === "products") {
      this.$router.push({
        name: "SpecialInitiativesProduct",
        params: { productId: item.id },
        query: { weekRange: weekRange },
      });
    }
    if (item.type === "brands") {
      this.$router.push({
        name: "SpecialInitiativesBrand",
        params: { brandId: item.id },
        query: { weekRange: weekRange },
      });
    }
  }
}
